exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.tag[data-v-3177f577]{display:inline-block;margin:0 0 11px;font-family:poppins,sans-serif;font-size:15px;font-weight:600}.clearfix[data-v-3177f577]{display:block;width:0;height:0;clear:both}.contact-form .error[data-v-3177f577]{background:#f93e3e;color:#fff;padding:16px 16px 0;margin-bottom:16px;width:100%}.contact-form .error p[data-v-3177f577]{padding:0 0 16px;margin:0}.form-sent[data-v-3177f577]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3177f577","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/contact-form/style.scss
// module id = 992
// module chunks = 0